import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import { useInstallationGuide } from '../../../hooks/useInstallationGuide';
import { AXON_LOGO_PATH } from '../../../utils/constants';

/**
 * LoadingStep - Slide 1.1: Loading/Splash screen
 * 
 * Initial loading screen shown while session data loads from localStorage.
 * Auto-advances to welcome or session-missing based on session state.
 */
export const LoadingStep: React.FC = () => {
  const { sessionState, goToStep } = useInstallationGuide();

  // Auto-advance based on session state
  useEffect(() => {
    if (sessionState === 'loading') {
      return; // Still loading
    }

    // Small delay for visual feedback
    const timer = setTimeout(() => {
      if (sessionState === 'ok') {
        goToStep('welcome');
      } else {
        goToStep('session-missing');
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [sessionState, goToStep]);

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f3ef',
      }}
    >
      {/* Axon logo */}
      <Box
        component="img"
        src={AXON_LOGO_PATH}
        alt={__('Axon')}
        sx={{
          height: 60,
          width: 'auto',
        }}
      />

      {/* Footer text */}
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          position: 'absolute',
          bottom: 24,
          left: 0,
          right: 0,
          textAlign: 'center',
        }}
      >
        {__('Axon Fusus Core Installation Guide')}
      </Typography>
    </Box>
  );
};
